import React, { useState, useEffect } from "react";
import {
    Grid,
    TablePagination,
    Backdrop,
    CircularProgress,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import axios from "axios";
import useStyles from "../../../themes/style.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Notification from "../../../components/Notification";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const positions = [toast.POSITION.TOP_RIGHT];
export default function VendorReport() {
    const classes = useStyles();
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const mobileQuery = useMediaQuery('(max-width:600px)');
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const userIdParam = queryParams.get("user_id");

    var [notificationsPosition] = useState(2);
    var [errorToastId, setErrorToastId] = useState(null);
    const [loader, setLoader] = useState(false);
    const [coinreportData, setCoinreportData] = useState([]);
    const [coinreportPage, setCoinreportPage] = useState(0);
    const [coinreportCurrerntPage, setCoinreportCurrerntPage] = useState(1);
    const [coinreportCount, setCoinreportCount] = useState(0);

    function sendNotification(componentProps, options) {
        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options,
        );
    }

    function handleNotificationCall(notificationType, message) {
        var componentProps;

        if (errorToastId && notificationType === "error") return;

        switch (notificationType) {
            case "info":
                componentProps = {
                    type: "feedback",
                    message: message,
                    variant: "contained",
                    color: "primary",
                };
                break;
            case "error":
                componentProps = {
                    type: "message",
                    message: message,
                    variant: "contained",
                    color: "secondary",
                };
                break;
            default:
                componentProps = {
                    type: "shipped",
                    message: message,
                    variant: "contained",
                    color: "success",
                };
        }

        var toastId = sendNotification(componentProps, {
            type: notificationType,
            position: positions[notificationsPosition],
            progressClassName: classes.progress,
            onClose: notificationType === "error" && (() => setErrorToastId(null)),
            className: classes.notification,
        });

        if (notificationType === "error") setErrorToastId(toastId);
    }

    const handleCoinReportChangePage = (event, newPage) => {
        let url = ""
        if (decoded.role === "ADMIN") {
            url = `${process.env.REACT_APP_SERVER}admin/getAllInvoiceableCandidates`
        } else if (decoded.role === "CLIENTCOORDINATOR") {
            url = `${process.env.REACT_APP_SERVER}CC/getAllInvoiceableCandidatesCC`
        } else {
            url = ""
        }

        setCoinreportPage(newPage);
        setLoader(true);
        setCoinreportCurrerntPage(newPage + 1);

        axios({
            method: "post",
            url: url,
            data: {
                recruiterId: userIdParam,
                page: newPage + 1
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {

            if (response.data.status === true) {
                setCoinreportData(response.data.data);
                setCoinreportCount(response.data.count);
            }
            setLoader(false);
        }).catch((err) => {
            setLoader(false);
            console.log(err);
        });
    };

    useEffect(() => {
        getAllVendorsReports();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getApprovalStatusColor(status) {
        let className;
        switch (status) {
            case "PENDING":
                className = "neutral-extrahigh"
                break;
            case "PAID":
                className = "positive-medium"
                break;
            case "REJECTED":
                className = "critical-low"
                break;
            default:
                className = "neutral-extrahigh"
                break;
        }
        return className;
    }

    const blinkIteration = {
        "--iteration-count": "infinite",
    };

    async function getAllVendorsReports() {
        let url = ""
        if (decoded.role === "ADMIN") {
            url = `${process.env.REACT_APP_SERVER}admin/getAllInvoiceableCandidates`
        } else if (decoded.role === "CLIENTCOORDINATOR") {
            url = `${process.env.REACT_APP_SERVER}CC/getAllInvoiceableCandidatesCC`
        } else {
            url = ""
        }
        try {
            setLoader(true)
            const response = await axios.post(url, {
                page: "1",
                id: userIdParam
            },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    }
                })
            setLoader(false);
            if (response.data.status === true) {
                setCoinreportData(response.data.data);
                setCoinreportCount(response.data.count);
            }
        } catch (error) {
            setLoader(false);
            handleNotificationCall("error", error)
            console.log(error)
        }
    }

    const HeaderElements = () => <>Total : {coinreportCount}</>;
    const renderValue = (record, item) => (
        <div style={{ background: 'transparent', borderRadius: '300px', padding: "0.1rem 0.4rem", display: "flex", alignItems: "center", gap: "0.2rem" }}>
            <span style={{ color: "#333" }}>{record?.value}</span>
        </div>
    );

    return (
        <>
            <Grid
                container
                direction="row"
                spacing={2}
                style={{ padding: "0px 10px" }}
            >
                <Grid
                    container
                    direction="row"
                    spacing={1}
                >

                    <Grid xs={12}>
                        <Grid container direction="row" spacing={2}>
                            <Grid item xs={12}   >
                                <MUIDataTable
                                    title=""
                                    options={{
                                        pagination: false,
                                        sort: false,
                                        selectableRows: "none",
                                        search: false,
                                        filter: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        responsive: mobileQuery === true ? 'vertical' : 'standard',
                                        customToolbar: () => <HeaderElements />,
                                        textLabels: {
                                            body: {
                                                noMatch: 'Oops! Matching record could not be found',
                                            }
                                        },
                                    }}
                                    columns={[
                                        {
                                            name: "S.No",
                                        },
                                        {
                                            name: "Candidate Name",
                                        },
                                        {
                                            name: "Requirement Name",
                                        },
                                        {
                                            name: "Payment Terms",
                                        },
                                        {
                                            name: "Commercial Flat Rate",
                                        },
                                        {
                                            name: "Status",
                                        },
                                        {
                                            name: "Posted Date",
                                        },
                                    ]}
                                    data={coinreportData.map((item, index) => {


                                        return [
                                            <>   {coinreportCurrerntPage !== 0 ? 10 * coinreportCurrerntPage - 10 + index + 1 : index + 1}  </>,
                                            <>   {item.candidate?.candidateDetail.firstName} {"(" + item.candidate?.candidateDetail.lastName + ")"} <br /> {"(" + item.candidate?.uniqueId + ")"}</>,
                                            <>   {item.candidate?.requirement?.requirementName} {"(" + item.candidate?.requirement?.uniqueId + ")"} </>,
                                            <>{item.candidate?.requirement?.joinedSharePercentage}</>,
                                            <>{item.candidate?.invoiceValue}</>,
                                            <>
                                                <div className={`status-tag ${getApprovalStatusColor(item.status)}`}>
                                                    <i
                                                        className={`highlight ${getApprovalStatusColor(item.status)}`}
                                                        style={blinkIteration}
                                                    ></i>
                                                    <p className='status-tag__txt bac-l-stack-xs' style={{ textTransform: 'capitalize' }}>{item.status}</p>
                                                </div>
                                            </>,
                                            moment(item.createdAt).format("DD-MM-YYYY"),
                                        ];
                                    })}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} className={classes.pagination}>
                            <TablePagination
                                rowsPerPageOptions={[50]}
                                component="div"
                                count={coinreportCount}
                                rowsPerPage={10}
                                page={coinreportPage}
                                onPageChange={handleCoinReportChangePage}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Backdrop className={classes.backdrop} open={loader}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Grid>
        </>
    );
}
